/* ==========================================================================
   AMADA 分类页交互 —— 2026-08-26 终稿（Figma tPnjQ1EbVgBhInGroWrTN6）
   ==========================================================================
   本文件只管三件事：
     ① SEE MORE：AJAX 追加下一页（不重复、不丢已加载卡片的心形状态）
     ② FILTERS 抽屉里的 SORT BY：切换排序
     ③ 「Discount highest to lowest」：Shopify 原生没有这个排序，
        对**已加载**的卡片做客户端重排（局限见 figma-qa/reports/amada-collection.md）

   ⚠️ 抽屉的开合**不在这里**——通用原语 assets/amada-drawer.js 已经用 document
      捕获阶段委托处理了 [data-amada-drawer-open]，这里一行都不许重复写。
   ⚠️ 心形收藏的数据层也不在这里——assets/amada-favorites.js 是唯一真源，
      本文件只在 AJAX 追加后**回刷新卡片的显示态**（那份 paint 是私有的，
      但 AmadaFavorites.has / hasProduct 是公开 API）。
   ========================================================================== */
(function () {
  'use strict';

  var SORT_PARAM_CUSTOM = 'amada_sort'; // 非 Shopify 原生排序（目前只有 discount）
  var CUSTOM_SORT_DISCOUNT = 'discount';

  /* ---------- 小工具 ---------- */

  function root() {
    return document.querySelector('[data-amada-collection]');
  }

  function grid() {
    return document.querySelector('[data-amada-collection-grid]');
  }

  function currentCustomSort() {
    try {
      return new URL(window.location.href).searchParams.get(SORT_PARAM_CUSTOM) || '';
    } catch (e) {
      return '';
    }
  }

  /* 卡片折扣率：价格取心形按钮上的 data 属性（分为单位，收藏契约里本来就有），
     没有划线价时算 0。返回 0~1。 */
  function discountRatio(card) {
    var heart = card.querySelector('[data-favorites-toggle]');
    if (!heart) return 0;
    var price = parseInt(heart.getAttribute('data-product-price'), 10);
    var compare = parseInt(heart.getAttribute('data-product-compare-price'), 10);
    if (isNaN(price) || isNaN(compare) || compare <= price || compare <= 0) return 0;
    return (compare - price) / compare;
  }

  /* ---------- ① 收藏显示态回刷（只针对新追加的卡片） ---------- */

  function paintFavorites(scope) {
    var api = window.AmadaFavorites;
    if (!api || !scope) return;
    var toggles = scope.querySelectorAll('[data-favorites-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var el = toggles[i];
      var handle = el.getAttribute('data-product-handle');
      if (!handle) continue;
      var variantId = el.getAttribute('data-variant-id');
      // 与 amada-favorites.js 的 paint 同口径：卡片心形按 handle 点亮
      var on = variantId ? api.has(handle, variantId) : api.hasProduct(handle);
      el.classList.toggle('is-favorited', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  /* ---------- ② 客户端折扣排序 ---------- */

  function applyDiscountSort() {
    var g = grid();
    if (!g) return;
    var cards = Array.prototype.slice.call(g.querySelectorAll('[data-amada-card]'));
    if (cards.length < 2) return;

    // 记录原始次序，保证同折扣率时顺序稳定（不同浏览器的 sort 稳定性靠这个兜底）
    cards.forEach(function (card, i) {
      card.__amadaIndex = i;
    });

    cards.sort(function (a, b) {
      var d = discountRatio(b) - discountRatio(a);
      if (d !== 0) return d;
      return a.__amadaIndex - b.__amadaIndex;
    });

    var frag = document.createDocumentFragment();
    cards.forEach(function (card) {
      frag.appendChild(card);
    });
    g.appendChild(frag);
  }

  /* ---------- ③ SEE MORE：追加下一页 ---------- */

  var loading = false;

  function loadMore(btn) {
    if (loading) return;
    var g = grid();
    var host = root();
    var nextUrl = btn.getAttribute('data-amada-next-url');
    var sectionId = host && host.getAttribute('data-amada-section-id');
    if (!g || !nextUrl || !sectionId) return;

    loading = true;
    btn.setAttribute('aria-busy', 'true');

    var url;
    try {
      url = new URL(nextUrl, window.location.origin);
    } catch (e) {
      loading = false;
      btn.removeAttribute('aria-busy');
      return;
    }
    // 只取这一个 section 的 HTML，不拉整页
    url.searchParams.set('section_id', sectionId);

    // 铁律 31：任何 fetch 都必须带超时，否则失败表现成无限转圈，看起来像 bug
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 15000);

    fetch(url.toString(), {
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-amada-collection-grid]');
        if (!nextGrid) throw new Error('no grid in response');

        // 去重：同一 handle 只保留一张卡（防止运营改了排序导致翻页重复）
        var seen = {};
        var existing = g.querySelectorAll('[data-amada-card]');
        for (var i = 0; i < existing.length; i++) {
          seen[existing[i].getAttribute('data-product-handle')] = true;
        }

        var frag = document.createDocumentFragment();
        var added = [];
        var incoming = nextGrid.querySelectorAll('[data-amada-card]');
        for (var j = 0; j < incoming.length; j++) {
          var handle = incoming[j].getAttribute('data-product-handle');
          if (handle && seen[handle]) continue;
          seen[handle] = true;
          var node = document.importNode(incoming[j], true);
          frag.appendChild(node);
          added.push(node);
        }
        g.appendChild(frag);

        // 新卡片的心形要按当前收藏数据重新点亮（它们不在页面加载时的那次 paint 里）
        added.forEach(function (node) {
          paintFavorites(node);
        });

        // 下一页按钮：响应里还有就更新 URL，没有就把按钮撤掉
        var nextBtn = doc.querySelector('[data-amada-see-more]');
        if (nextBtn && nextBtn.getAttribute('data-amada-next-url')) {
          btn.setAttribute('data-amada-next-url', nextBtn.getAttribute('data-amada-next-url'));
          btn.setAttribute('href', nextBtn.getAttribute('href') || nextBtn.getAttribute('data-amada-next-url'));
        } else {
          btn.parentNode.removeChild(btn);
        }

        // 折扣排序是客户端的，追加完必须重排一次，否则新卡片全堆在末尾
        if (currentCustomSort() === CUSTOM_SORT_DISCOUNT) applyDiscountSort();
      })
      .catch(function () {
        /* 失败就退回「普通链接」语义：让用户点一次跳转到下一页，
           而不是卡在 loading 态里 —— 按钮本来就带 href。 */
        btn.removeAttribute('data-amada-next-url');
      })
      .then(function () {
        window.clearTimeout(timer);
        loading = false;
        btn.removeAttribute('aria-busy');
      });
  }

  /* ---------- ④ SORT BY ---------- */

  function applySort(value) {
    var url;
    try {
      url = new URL(window.location.href);
    } catch (e) {
      return;
    }

    url.searchParams.delete('page'); // 换排序一律回到第一页

    if (value === 'relevancy') {
      url.searchParams.delete('sort_by');
      url.searchParams.delete(SORT_PARAM_CUSTOM);
    } else if (value === CUSTOM_SORT_DISCOUNT) {
      // Shopify 没有折扣排序，交给客户端；同时把原生排序清掉，避免两套排序打架
      url.searchParams.delete('sort_by');
      url.searchParams.set(SORT_PARAM_CUSTOM, CUSTOM_SORT_DISCOUNT);
    } else {
      url.searchParams.set('sort_by', value);
      url.searchParams.delete(SORT_PARAM_CUSTOM);
    }

    window.location.assign(url.toString());
  }

  /* ---------- 事件委托 ----------
     注册在**捕获阶段**：主题自己也在 document 上监听 click，
     冒泡阶段会被它抢先（PDP Size Guide 那次实证）。 */

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-amada-see-more]');
      if (!btn) return;
      // 没有 data-amada-next-url 说明 AJAX 失败过一次，放行成普通链接跳转
      if (!btn.getAttribute('data-amada-next-url')) return;
      e.preventDefault();
      /* 双保险：主题 theme.js 的 pageTransition 在 body 上代理了所有 a[href]，
         并且 **不看 defaultPrevented**，200ms 后硬写 location.href。
         按钮上已经加了主题官方的退出类 no-transition；这里再把事件掐在 document
         捕获阶段，保证它压根到不了 body 的委托。 */
      e.stopPropagation();
      loadMore(btn);
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target.closest && e.target.closest('[data-amada-sort-option]');
      if (!input || !input.checked) return;
      applySort(input.value);
    },
    true
  );

  /* ---------- 首次进页面 ---------- */

  function init() {
    if (!root()) return;
    if (currentCustomSort() === CUSTOM_SORT_DISCOUNT) {
      // 服务端不知道这个排序，单选态要在这里补上（Liquid 里 collection.sort_by 是空的）
      var input = document.querySelector('[data-amada-sort-option][value="' + CUSTOM_SORT_DISCOUNT + '"]');
      if (input) input.checked = true;
      applyDiscountSort();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
